import { handleAPI, API_VERSION_ONE_ADMIN } from '../../../utils/apiUtils';
const parent = 'SETTING_'

export function impressionPlansLoad(filters) {
  const url = `/${API_VERSION_ONE_ADMIN}/settings/associated_plans`;
  const method = 'GET'

  return {
    type: `${parent}IMPRESSION_PLANS_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}

export function impressionPlanCreate(data, filters) {
  const url = `/${API_VERSION_ONE_ADMIN}/settings/associated_plans`;
  const method = 'POST'

  return {
    type: `${parent}IMPRESSION_PLAN_CREATE`,
    payload: handleAPI(url, filters, method, data)
  };
}

export function impressionPlanUpdate(data, filters) {
  const url = `/${API_VERSION_ONE_ADMIN}/settings/associated_plans/${data.id}`;
  const method = 'PUT'

  return {
    type: `${parent}IMPRESSION_PLAN_UPDATE`,
    payload: handleAPI(url, filters, method, data)
  };
}

export function impressionPlanDelete(id, filters) {
  const url = `/${API_VERSION_ONE_ADMIN}/settings/associated_plans/${id}`;
  const method = 'DELETE'

  return {
    type: `${parent}IMPRESSION_PLAN_DELETE`,
    payload: handleAPI(url, filters, method)
  };
}